import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/representatives`, { params: params }),
    get: (id) => axios.get(`/representatives/${id}`),
    create: (data) => axios.post(`/representatives`, data),
    update: (id, data) => axios.put(`/representatives/${id}`, data),
    updateAsForm(id, data) {
        data.append("_METHOD", "PUT");
        return axios.post(`/representatives/${id}`, data);
    },
    delete: (id) => axios.delete(`/representatives/${id}`),
    deleteAvatar: (id) => axios.delete(`/representatives/${id}/delete-avatar`),
    enable: (id) => axios.patch(`/representatives/${id}/enable`),
    disable: (id) => axios.patch(`/representatives/${id}/disable`),
    getMessages: (id, params) => axios.get(`/representatives/${id}/messages`, { params: params }),
    getPhotos: (id) => axios.get(`/representatives/${id}/latest-photos`),
    getDocs: (id) => axios.get(`/representatives/${id}/latest-documents`),
    sendMail: (id) => axios.post(`/representatives/${id}/send-mail`),
}